import { render } from "./app-logo-visa.vue?vue&type=template&id=9f39d038"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-visa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f39d038"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f39d038', __exports__)) {
    console.log('reload')
    api.reload('9f39d038', __exports__)
  }
  
  module.hot.accept("./app-logo-visa.vue?vue&type=template&id=9f39d038", () => {
    console.log('re-render')
    api.rerender('9f39d038', render)
  })

}


export default __exports__